import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { CommonService } from "../../common.service";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CountryListsService } from "../../country-lists.service";
import { Guid } from "../../utils/guid";
import { AppFolioService } from "src/app/_services/appfolioService";
import { AppFolioSignUpCompany } from "../../_models/appfolioSignUpCompany";
import { TokenLogService } from "src/app/_services/tokenLogService";
import { LogEntry } from "src/app/_models/logEntry";

@Component({
  selector: "appfolio-registration",
  templateUrl: "./appfolio-registration.component.html",
  styleUrls: ["./appfolio-registration.component.css"],
})
export class AppfolioRegistrationComponent implements OnInit {
  public sessionId: string;
  public addressChecking: FormControl = new FormControl(false);
  public registrationForm: FormGroup;
  public error: string;
  public values: any;
  public stateCityData = [];
  public countryName: any;
  public stateName: any;
  public cityName: any;
  public noMatchStateCity: any = 0;
  public selectedCity: any = 0;
  public clientNameError: any;
  // public companyLegalNameError: any;
  public addressError: any;
  public address2Error: any;
  public countryError: any;
  public cityError: any;
  public stateError: any;
  public contactFirstNameError: any;
  public extensionError: any;
  public phoneError: any;
  public contactEmailAddressError: any;
  public contactNumUnitsError: any;
  public contactNumPropertyError: any;
  public vHostNameError: any;
  // public authorizationPercentageError: any;
  public zipCodeError: any;
  public contactLastNameError: any;
  public defaultCityValue: any = "Select your City";
  public allCountries = [];
  public getFirstRegistrationFormVal: any;
  public defaultCheck1Error: any;
  private isLoading: boolean;
  public apiResponseError: any;
  public apiResponseErrorMsg: any;
  public mask = {
    guide: true,
    mask: [
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
  };

  public extensionMask = {
    guide: true,
    mask: [/\d/, /\d/, /\d/, /\d/],
  };
  private AppFolioRegistrationDetails: string =
    "appfolioFirstRegistrationDetails";
  constructor(
    private _FB: FormBuilder,
    public authService: CommonService,
    private router: Router,
    private spinner: NgxSpinnerService,
    public countryService: CountryListsService,
    private readonly appfolioService: AppFolioService,
    private readonly logService: TokenLogService
  ) {
    this.registrationForm = this._FB.group({
      clientName: ["", Validators.compose([Validators.required])],
      NumProperty: ["", Validators.compose([Validators.required])],
      NumUnits: ["", Validators.compose([Validators.required])],
      address: ["", Validators.compose([Validators.required])],
      city: ["", Validators.compose([Validators.required])],
      state: ["", Validators.compose([Validators.required])],
      country: ["", Validators.compose([Validators.required])],
      contactFirstName: ["", Validators.compose([Validators.required])],
      phone: [
        "",
        Validators.compose([
          Validators.pattern(
            "^(1s?)?((([0-9]{3}))|[0-9]{3})[s-]?[\0-9]{3}[s-]?[0-9]{4}$"
          ),
        ]),
      ],
      contactEmailAddress: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(
            "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{1,63}$"
          ),
        ]),
      ],
      zipCode: ["", Validators.compose([Validators.required])],
      contactLastName: ["", Validators.compose([Validators.required])],
      extension: [""],
      vHostName: ["", Validators.compose([Validators.required])],
      // authorizationPercentage: [
      //   "Best: 50% (50% discount)",
      //   Validators.compose([Validators.required]),
      // ],
    });
  }

  showSpinner() {
    this.spinner.show("mySpinner", {
      type: "line-scale-party",
      size: "large",
      bdColor: "rgba(100,149,237, .8)",
      color: "black",
    });
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
  }

  ngOnInit() {
    const vHostname: string = this.router.parseUrl(this.router.url).queryParams[
      "vhost"
    ];
    this.registrationForm.controls["vHostName"].setValue(vHostname);
    this.appfolioService
      .getClientIPAddress()
      .toPromise()
      .then((response) => {
        localStorage.setItem("clientIPAddress", response["ip"]);
      })
      .catch((error) => {
        console.log(error);
      });

    this.sessionId = Guid.newGuid();
    localStorage.setItem("sessionId", this.sessionId);

    this.allCountries = this.countryService.allCountryLists;
    this.registrationForm.controls["country"].setValue(
      this.allCountries[231]["code"]
    );

    this.getFirstRegistrationFormVal = JSON.parse(
      localStorage.getItem(this.AppFolioRegistrationDetails)
    );

    if (this.getFirstRegistrationFormVal) {
      this.registrationForm.controls["clientName"].setValue(
        this.getFirstRegistrationFormVal["Name"]
      );

      this.registrationForm.controls["NumProperty"].setValue(
        this.getFirstRegistrationFormVal["NumProperty"]
      );

      this.registrationForm.controls["NumUnits"].setValue(
        this.getFirstRegistrationFormVal["NumUnits"]
      );

      this.registrationForm.controls["address"].setValue(
        this.getFirstRegistrationFormVal["Address"]
      );

      this.registrationForm.controls["country"].setValue(
        this.getFirstRegistrationFormVal["Country"]
      );
      this.registrationForm.controls["zipCode"].setValue(
        this.getFirstRegistrationFormVal["ZipCode"]
      );
      this.registrationForm.controls["city"].setValue(
        this.getFirstRegistrationFormVal["City"]
      );
      this.registrationForm.controls["state"].setValue(
        this.getFirstRegistrationFormVal["State"]
      );
      this.countryName = this.getFirstRegistrationFormVal["Country"];
      this.registrationForm.controls["contactFirstName"].setValue(
        this.getFirstRegistrationFormVal["FirstName"]
      );
      this.registrationForm.controls["phone"].setValue(
        this.getFirstRegistrationFormVal["Phone"]
      );
      this.registrationForm.controls["contactEmailAddress"].setValue(
        this.getFirstRegistrationFormVal["Email"]
      );
      this.registrationForm.controls["contactLastName"].setValue(
        this.getFirstRegistrationFormVal["LastName"]
      );
      this.registrationForm.controls["extension"].setValue(
        this.getFirstRegistrationFormVal["Extension"]
      );

      // this.registrationForm.controls["authorizationPercentage"].setValue(
      //   this.getFirstRegistrationFormVal[
      //     "AuthorizationPercentage"
      //   ]
      // );
    }
  }

  get companyName() {
    return this.registrationForm.get("companyName").value;
  }
  get NumProperty() {
    return this.registrationForm.get("NumProperty").value;
  }
  get NumUnits() {
    return this.registrationForm.get("NumUnits").value;
  }
  get country() {
    return this.registrationForm.get("country").value;
  }
  get city() {
    return this.registrationForm.get("city").value;
  }
  get state() {
    return this.registrationForm.get("state").value;
  }
  get contactFirstName() {
    return this.registrationForm.get("contactFirstName").value;
  }
  get phone() {
    return this.registrationForm.get("phone").value;
  }
  get extension() {
    return this.registrationForm.get("extension").value;
  }
  get contactEmailAddress() {
    return this.registrationForm.get("contactEmailAddress").value;
  }
  get zipCode() {
    return this.registrationForm.get("zipCode").value;
  }
  get contactLastName() {
    return this.registrationForm.get("contactLastName").value;
  }

  get vHostName() {
    return this.registrationForm.get("vHostName").value;
  }

  get address() {
    return this.registrationForm.get("address").value;
  }

  clickRegistration() {
    if (this.registrationForm.controls.clientName.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.clientNameError = "Company name is required.";
    } else if (this.registrationForm.controls.NumProperty.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.addressError = "Number of Properties is required.";
    } else if (this.registrationForm.controls.NumUnits.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.addressError = "Number of Units is required.";
    } else if (this.registrationForm.controls.address.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.addressError = "Address is required.";
    } else if (this.registrationForm.controls.country.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.countryError = "Country is required.";
    } else if (this.registrationForm.controls.zipCode.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.zipCodeError = "Zip code is required.";
    } else if (this.registrationForm.controls.city.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.cityError = "Physical address city is required.";
    } else if (this.registrationForm.controls.state.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.stateError = "Physical address state is required.";
    } else if (
      this.registrationForm.controls.contactFirstName.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactFirstNameError = "First name is required.";
    } else if (
      this.registrationForm.controls.contactLastName.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactLastNameError = "Last name is required.";
    } else if (this.registrationForm.controls.phone.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.phoneError = "Phone no is required.";
    } else if (this.registrationForm.controls.extension.hasError("pattern")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.extensionError = "Please enter a valid extension";
    } else if (
      this.registrationForm.controls.contactEmailAddress.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactEmailAddressError = "Email is required.";
    } else if (
      this.registrationForm.controls.contactEmailAddress.hasError("pattern")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactEmailAddressError = "Please enter a valid email.";
    } else if (this.registrationForm.controls.vHostName.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.vHostNameError = "Vhost Name is required.";
    } else {
      this.isLoading = true;
      this.apiResponseError = 0;
      const clientSignUpCompany: AppFolioSignUpCompany = {
        clientName: this.registrationForm.controls["clientName"].value,
        NumProperty: this.registrationForm.controls["NumProperty"].value,
        NumUnits: this.registrationForm.controls["NumUnits"].value,
        firstName: this.registrationForm.controls["contactFirstName"].value,
        lastName: this.registrationForm.controls["contactLastName"].value,
        phone: this.registrationForm.controls["phone"].value,
        email: this.registrationForm.controls["contactEmailAddress"].value,
        extension: this.registrationForm.controls["extension"].value,
        address: this.registrationForm.controls["address"].value,
        city: this.registrationForm.controls["city"].value,
        state: this.registrationForm.controls["state"].value,
        zipCode: this.registrationForm.controls["zipCode"].value,
        country: this.countryName,
        sessionId: this.sessionId,
        vHostName: this.registrationForm.controls["vHostName"].value.trim(),
      };

      let firstRegistrationFormData = {};
      firstRegistrationFormData["Name"] =
        this.registrationForm.controls["clientName"].value;
      firstRegistrationFormData["NumProperty"] =
        this.registrationForm.controls["NumProperty"].value;
      firstRegistrationFormData["NumUnits"] =
        this.registrationForm.controls["NumUnits"].value;
      firstRegistrationFormData["Address"] =
        this.registrationForm.controls["address"].value;
      firstRegistrationFormData["City"] =
        this.registrationForm.controls["city"].value;
      firstRegistrationFormData["State"] =
        this.registrationForm.controls["state"].value;
      firstRegistrationFormData["Country"] = this.countryName;
      firstRegistrationFormData["ZipCode"] =
        this.registrationForm.controls["zipCode"].value;
      firstRegistrationFormData["FirstName"] =
        this.registrationForm.controls["contactFirstName"].value;
      firstRegistrationFormData["LastName"] =
        this.registrationForm.controls["contactLastName"].value;
      firstRegistrationFormData["Phone"] =
        this.registrationForm.controls["phone"].value;
      firstRegistrationFormData["Extension"] =
        this.registrationForm.controls["extension"].value;
      firstRegistrationFormData["Email"] =
        this.registrationForm.controls["contactEmailAddress"].value;
      firstRegistrationFormData["VHostName"] =
        this.registrationForm.controls["vHostName"].value.trim();

      if (firstRegistrationFormData) {
        localStorage.setItem(
          this.AppFolioRegistrationDetails,
          JSON.stringify(firstRegistrationFormData)
        );

        localStorage.setItem(
          "appfolioSigUpCompany",
          JSON.stringify(clientSignUpCompany)
        );

        // this.appfolioService
        //   .validateVHostName(this.vHostName)
        //   .toPromise()
        //   .then((_) => {
        const {
          Name,
          NumProperty,
          NumUnits,
          Address,
          City,
          Country,
          Email,
          FirstName,
          LastName,
          Phone,
          State,
          ZipCode,
        } = JSON.parse(
          localStorage.getItem("appfolioFirstRegistrationDetails")
        );
        const sessionId = localStorage.getItem("sessionId");
        const logEntry: LogEntry = {
          pageNumber: 1,
          companyName: Name,
          vendorClientUniqueId: null,
          message: "Client provided Company information",
          exception: null,
          clientId: null,
          clientSecret: null,
          email: Email,
          phone: Phone,
          contactName: FirstName + " " + LastName,
          sessionId: sessionId,
          password: null,
          companyLegalName: null,
          numberOfProperties: NumProperty,
          numberOfUnits: NumUnits,
          street1: Address,
          city: City,
          state: State,
          zipCode: ZipCode,
          country: Country,
          settlementAuth: "80",
          clientVendorId: 2,
        };

        this.logService
          .logEntry(logEntry)
          .toPromise()
          .then(() => {
            console.log("Token entry set correctly");
          })
          .catch((error) => {
            console.log(
              "An error has occurred while creating log entry: ",
              error
            );
          });

        this.router.navigate(["/appfolio/contract"]);
        // })
        // .catch((error) => {
        //   this.apiResponseError = 1;
        //   this.apiResponseErrorMsg =
        //     typeof error.error == "string"
        //       ? error.error
        //       : error.message || error.error;
        //   this.isLoading = false;
        // });

        // this.appfolioService
        //   .saveAppFolioCompany(clientSignUpCompany)
        //   .toPromise()
        //   .then(() => {
        //     localStorage.setItem(this.AppFolioRegistrationDetails, null);
        //     this.router.navigate(["/appfolio/contract"]);
        //   })
        //   .catch((error) => {
        //     console.log(error);

        //     this.apiResponseError = 1;
        //     this.apiResponseErrorMsg =
        //       typeof error.error == "string"
        //         ? error.error
        //         : error.message || error.error;
        //     this.isLoading = false;
        //   });
      }
    }
  }

  changePhysicalAddressStateCity(selectedValue: any) {
    this.values = selectedValue.target.value;
    if (this.values != "") {
      this.stateName = "";
      this.cityName = "";
      this.noMatchStateCity = 0;
      if (!this.registrationForm.controls.zipCode.hasError("pattern")) {
        this.authService.getStateCity(this.values).subscribe(
          (stateCityval) => {
            if (stateCityval["results"].length > 0) {
              this.stateCityData =
                stateCityval["results"][0]["address_components"];
              if (
                typeof this.stateCityData != "undefined" &&
                typeof this.stateCityData &&
                this.stateCityData.length > 0
              ) {
                this.stateCityData.forEach((stateDataAllValue) => {
                  stateDataAllValue["types"].forEach((stateDataTypeValue) => {
                    if (stateDataTypeValue == "administrative_area_level_1") {
                      this.stateName = stateDataAllValue["short_name"];
                      this.registrationForm.controls["state"].setValue(
                        this.stateName
                      );
                    }
                    if (stateDataTypeValue == "locality") {
                      this.cityName = stateDataAllValue["long_name"];
                      this.registrationForm.controls["city"].setValue(
                        this.cityName
                      );
                    }
                    if (stateDataTypeValue == "country") {
                      this.countryName = stateDataAllValue["short_name"];
                      this.registrationForm.controls["country"].setValue(
                        stateDataAllValue["short_name"]
                      );
                      this.registrationForm.controls["country"].disable();
                    }
                  });
                });
              }
            } else {
              this.noMatchStateCity = 1;
              this.registrationForm.controls["state"].setValue("");
              this.registrationForm.controls["city"].setValue("");
              // this.registrationForm.controls["country"].enable();
            }
          },
          (error) => (this.error = error)
        );
      } else {
        this.noMatchStateCity = 1;
        this.registrationForm.controls["state"].setValue("");
        this.registrationForm.controls["city"].setValue("");
        this.countryName = "";
      }
    } else {
      this.noMatchStateCity = 0;
      this.registrationForm.controls["state"].setValue("");
      this.registrationForm.controls["city"].setValue("");
    }
  }

  onOptionsSelected(event) {
    if (event == 100) {
      alert(
        "Are you sure? Not enabling a settlement offer can have a dramatic impact on our ability to collect on your accounts."
      );
    }
  }
}
